import fetchFromApiServer from 'services/api';

export function fetchCompanyEntities(requestObject) {
  const url = `company-page/get-all-company`;
  return fetchFromApiServer('GET', url, requestObject);
}
